import React from 'react';

export default (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 38 38" name="person" role="img" aria-label="person">
    <path
      fill="#F0EAE1"
      d="M0 19C0 8.50659 8.50659 0 19 0c10.4934 0 19 8.50659 19 19 0 10.4934-8.5066 19-19 19C8.50659 38 0 29.4934 0 19Z"
    />
    <path
      fill="#fff"
      d="M32.127 32.7362C28.7158 35.9971 24.0918 38 19 38c-5.0918 0-9.71575-2.0029-13.12704-5.2638C8.43126 28.1227 13.351 25 19 25c5.649 0 10.5687 3.1227 13.127 7.7362ZM19 23c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8Z"
    />
    <path
      fill="#000"
      d="M6.25058 33.0875a19.04769 19.04769 0 0 1-.37762-.3513C8.43126 28.1227 13.351 25 19 25c5.649 0 10.5687 3.1227 13.127 7.7362-.1242.1188-.2501.2359-.3776.3513C29.2938 28.568 24.5052 25.5 19 25.5c-5.5052 0-10.29385 3.068-12.74942 7.5875Z"
    />
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M19 23c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8Zm0-.5c4.1421 0 7.5-3.3579 7.5-7.5S23.1421 7.5 19 7.5s-7.5 3.3579-7.5 7.5 3.3579 7.5 7.5 7.5Z"
      clip-rule="evenodd"
    />
  </svg>
);
